import { isEmpty } from 'lodash-es';
import { IConsultant, ISMTPAccountsResponse } from 'wisestep-api';

const hotJobsEmailTemplate = (
  defaultAccounts: ISMTPAccountsResponse[],
  consultant?: IConsultant
) => {
  let emailContent = '';
  if (!isEmpty(defaultAccounts)) {
    const selectedAccount = defaultAccounts[0];
    const signature = isEmpty(selectedAccount.signatureText) ? '' : selectedAccount.signatureText;
    let body =
      '<p>Hi,<br><br><p>Please find below for the consultant?s matching your requirements.<br>';
    if (!isEmpty(consultant?.name)) body = body + '<br> <b>Name:</b> ' + consultant?.name;
    if (!isEmpty(consultant?.email)) body = body + '<br> <b>Email:</b> ' + consultant?.email;
    if (!isEmpty(consultant?.jobTitle))
      body = body + '<br> <b>Job Title:</b> ' + consultant?.jobTitle;
    if (!isEmpty(consultant?.visaStatus))
      body = body + '<br> <b>Visa Status:</b> ' + consultant?.visaStatus;
    if (consultant?.skills && consultant?.skills?.length > 0)
      body =
        body +
        '<br> <b>Skills:</b> ' +
        consultant?.skills
          .map(function (s) {
            return s.skill;
          })
          .join();
    if (!isEmpty(consultant?.location) && consultant?.location != null)
      body =
        body +
        '<br> <b>Location:</b> ' +
        consultant?.location.country +
        ',' +
        consultant?.location.state +
        ',' +
        consultant?.location?.city;
    emailContent = body + '</p>' + signature;
  }
  return emailContent;
};

export default hotJobsEmailTemplate;
